<template>
	<div>
    <div class="m_context">
		<el-row :gutter="20" style="margin-bottom: 20px;">

	        <el-col :span="4" style="padding-left: 24px;">
		        <el-select v-model="selectType" @change="typeChange" placeholder="" style='width:100%'>
		          <el-option
		            v-for="item in type"
		            :label="item.label"
		            :value="item.value"
								:key="item.id">
		          </el-option>
		        </el-select>
			</el-col>
			<el-col :span="5">
		        <el-input
              :placeholder="$t('lin_global.tgmccz')"
	  			  icon="search"
	  			  v-model="name"
	  			  :on-icon-click="handleIconClick">
	  			</el-input>
	        </el-col>

		</el-row>
     <el-table
	  	:data="arrdata"
      id="tp"
      v-loading="loading"
	  	border
	  	style="width:100%;"
	  	ref="arrdata"
	  	@row-click="rowClick">
	  		<el-table-column
	  		prop="name"
	  		:label="$t('lin_global.name')">
	  		</el-table-column>
	  		<el-table-column
	  		prop="version"
        :label="$t('lin_global.version')"
	  		width="180">
	  		</el-table-column>

	  		<el-table-column
	  		prop="type"
        :label="$t('terminal.details.animatType')"
	  		width="150">
	  		</el-table-column>
	  		<el-table-column
	  		prop="mechanismName"
        :label="$t('lin_global.label_areaid')">
	  		</el-table-column>
	  		<el-table-column
	  		prop="opetime"
        :label="$t('lin_global.uploadTime')">
	  		</el-table-column>

	  		<el-table-column
	  		prop=""
				align='center'
				width=''
        :label="$t('app_operate')">
					<template slot-scope='scope'>
						<!-- <el-button type='text'>{{$t('app_verify')}}</el-button> -->
						<el-tooltip class="item" effect="dark" :content="$t('app_verify')" placement="top">
							<el-button type='text'><i class="fa fa-check-square-o" style=""></i></el-button>
						</el-tooltip>
					</template>
	  		</el-table-column>

	  	</el-table>
	  	<div class="page_content" v-if="totalRecords > 0">
		  <el-pagination style='float:right;'
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    :current-page="currentPage"
		    :page-sizes="[10,50,100]"
		    :page-size="pageSize"
		    layout="total, sizes, prev, pager, next, jumper"
		    :total="totalRecords">
		  </el-pagination>
		</div>
    </div>
	</div>
</template>

<script>
	import axios from 'axios'
    import { baseurl } from '../../api/url'
	export default{
		data(){
			return{
				selectType:'',
				arrdata:[],
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
        loading: true,
				name:'',
				type: [{
			        value: '',
			        label: this.$t('lin_global.allType')
			      }, {
			        value: 'ota',
			        label: 'OTA'
			      }, {
			        value: 'rom',
			        label: 'ROM'
			    }]
			}
		},
		created(){ 
			this.getData(1,'')
		},
		mounted () {
		},
		methods:{
			rowClick:function(row){
				this.$router.push({
					path:'/romReview/'+row.id+'/reviewDetail'
				})
			},
			typeChange:function(){
				this.getData(1,this.name);
			},
			handleIconClick:function(){
				this.getData(1,this.name);
			},
			handleSizeChange: function (val) {
		        this.pageSize = val
		        this.getData(this.currentPage)
		        //console.log(`每页 ${val} 条`)
		    },
		    handleCurrentChange: function (val) {
		        this.currentPage = val
		        this.getData(this.currentPage)
		        //console.log('当前页: ${val}')
		    },
			getData:function(page,name){
				this.currentPage = page;
				var params = {page:page,rows:this.pageSize,type:this.selectType,name:name,status:1};
				//console.log("看看是何方参数");
				//console.log(params);
				axios.post(`${baseurl}/ota_rom/list.do`,params).then(res=>{
					//console.log("打印返回ORM列表")
					//console.log(res.data);
					if(res.data.status == 200){
            this.arrdata = res.data.data;
            this.totalRecords = res.data.total;
            for(var i = 0;i<res.data.data.length;i++){
              if(res.data.data[i].status == 0){
                res.data.data[i]['submit'] = true;
                res.data.data[i]['edit'] = true;
                res.data.data[i]['delete'] = true;
              }else if(res.data.data[i].status == 1){
                res.data.data[i]['submit'] = false;
                res.data.data[i]['edit'] = false;
                res.data.data[i]['delete'] = false;
              }else if(res.data.data[i].status == 2){
                res.data.data[i]['submit'] = false;
                res.data.data[i]['edit'] = false;
                res.data.data[i]['delete'] = true;
              }else if(res.data.data[i].status == 3){
                res.data.data[i]['submit'] = false;
                res.data.data[i]['edit'] = true;
                res.data.data[i]['delete'] = true;
              }else{
                return false
              }
            }
            this.loading = false;
          }else{
            this.loading = false;
          }

				})
			},
			formatStatus:function(row,column){
		      return row.status == 0?this.$t('lin_global.waitOne'):row.status == 1?this.$t('lin_global.waitTwo'):row.status == 2?this.$t('lin_global.verifyPass'):row.status == 3?this.$t('lin_global.verifyNotPass'):'';
		    },
		}
	}
</script>



// WEBPACK FOOTER //
// romReview.vue?ea25d952